import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type ReferralListItem = {
  id: number;
  email: string;
  hasSubscription: boolean;
  subscriptionDate: string | null;
  isConfirmed: boolean;
};

export type ReferralHistoryItem = {
  id: number;
  payerEmail: string;
  amount: number;
  commissionPercent: number;
  commissionAmount: number;
  note: string | null;
  createdAt: string;
};

export type ReferralSummary = {
  referralCode: string;
  referralLink: string;
  referralPercent: number;
  totalReferrals: number;
  activeSubscriptions: number;
  balance: number;
  referrals: ReferralListItem[];
  history: ReferralHistoryItem[];
};

const initialState: {
  summary?: ReferralSummary;
  loading: boolean;
} = {
  summary: undefined,
  loading: false,
};

export const referralReducer = createSlice({
  name: 'referral',
  initialState,
  reducers: {
    loadReferralSummary(state) {
      state.loading = true;
    },
    setReferralSummary(state, action: PayloadAction<ReferralSummary>) {
      state.summary = action.payload;
      state.loading = false;
    },
    referralSummaryFailed(state) {
      state.loading = false;
    },
  },
});

export const { loadReferralSummary, setReferralSummary, referralSummaryFailed } =
  referralReducer.actions;
